
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class AppSetting extends Vue {
  @Prop({ type: String, default: '' })
  public title!: string

  @Prop({ type: String })
  public subTitle!: string

  @Prop({ type: String })
  public help!: string

  @Prop({ type: String })
  public accentColor!: string

  @Prop({ type: Number, default: 6 })
  public rCols!: number

  get cols () {
    return [12 - this.rCols, this.rCols]
  }

  get hasClick () {
    return this.$listeners && this.$listeners.click
  }

  get hasSubTitle () {
    return (
      this.$slots['sub-title'] ||
      this.$scopedSlots['sub-title'] ||
      this.subTitle
    )
  }

  get classes () {
    return {
      setting__link: this.hasClick
    }
  }
}
